// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.input-container > input[data-v-2b5151d8] {\n  width: 100%;\n  padding: 8px;\n  display: block;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  color: inherit;\n  box-sizing: border-box;\n  background-color: transparent;\n  outline: none;\n}\n.input-container > input[data-v-2b5151d8]:focus {\n  border: 1px solid #fff;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
